// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__SOg7a","clinicsSelect":"styles_clinicsSelect__z3TJ6"};